<script setup>
// §8.4 EntrySourceBadge — Automated / Manual / Meeting / Visit.
// NOTE (§10, open item): the time-type taxonomy is not yet ruled first-class,
// so this is a NEUTRAL provenance marker — grey, not a status hue, never a
// carrier of billable/personal meaning (§6.4). It states where an entry came
// from, nothing more. Shape + label, never colour alone.
import { computed } from 'vue'
import LIcon from '../base/Icon.vue'

const props = defineProps({
  source: { type: String, default: 'automated' }, // automated | manual | meeting | visit
})

const MAP = {
  automated: { label: 'Automated', icon: 'microchip' },
  manual: { label: 'Manual', icon: 'pen' },
  meeting: { label: 'Meeting', icon: 'users' },
  visit: { label: 'Visit', icon: 'location-dot' },
}
const meta = computed(() => MAP[props.source] ?? MAP.automated)
</script>

<template>
  <span class="l-source">
    <LIcon :name="meta.icon" :size="11" />
    {{ meta.label }}
  </span>
</template>

<style scoped>
.l-source {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: var(--text-micro);
  font-weight: 600;
  letter-spacing: 0.2px;
  text-transform: uppercase;
  color: var(--text-3);
  background: var(--surface-sunken);
  border: 1px solid var(--line-soft);
  border-radius: var(--r-sm);
  padding: 2px 7px;
  white-space: nowrap;
}
.l-source :deep(i) {
  color: var(--icon);
}
</style>
